import { Card } from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import { useTranslation } from "react-i18next";
import "./css/cartTotal.scss";

interface IParams {
    monthlyAmount: number;
    oneOffChargeAmount: number;
}

export const CartTotal = (props: IParams) => {
    const { monthlyAmount, oneOffChargeAmount } = props;
    const { t } = useTranslation(["cart", "common"]);

    return (
        <Card className="cart-total-container" elevation={2}>
            <CardContent className="cart-total-content">
                <Typography color="inherit" gutterBottom variant="h3">
                    {t("cart:yourBasket")}
                </Typography>
                <Grid className="cart-total-content__info xtest_cart_total" container justify="space-between">
                    <Grid
                        alignItems="center"
                        className="cart-total-content__monthly"
                        container
                        item
                        justify="space-between"
                        md={5}
                        xs={12}
                    >
                        <Grid item md={9} sm={10} xs={9}>
                            <Typography color="inherit" variant="body1">
                                {t("cart:totalMonthly")}
                            </Typography>
                        </Grid>
                        {monthlyAmount && (
                            <Grid className="cart-total-content__price" item md={3} sm={2} xs={3}>
                                <Typography align="right" color="inherit" variant="h5">
                                    {t("common:price", { price: monthlyAmount })}
                                </Typography>
                            </Grid>
                        )}
                    </Grid>
                    <Grid
                        alignItems="center"
                        className="cart-total-content__once"
                        container
                        item
                        justify="space-between"
                        md={5}
                        xs={12}
                    >
                        <Grid item md={9} sm={10} xs={9}>
                            <Typography color="inherit" variant="body1">
                                {t("cart:totalActivation")}
                            </Typography>
                        </Grid>
                        <Grid className="cart-total-content__price" item md={3} sm={2} xs={3}>
                            <Typography align="right" color="inherit" variant="h5">
                                {t("common:price", { price: oneOffChargeAmount })}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};
